const SKU_PATTERN = /^(?:EX)?(\d{8})$/i;

export const isSkuSearch = (value: string): boolean => SKU_PATTERN.test(value.trim());

export const normalizeSku = (value: string): string => {

  const match = value.trim().match(SKU_PATTERN);

  if (!match) {

    return value.trim();

  }

  return `EX${match[1]}`;

};
